<template>

    <div class="bloc-login-container">

        <div class="bloc-login">

            <h1 class="title-login">{{ getTitle }}</h1>

            <span class="subtitle">{{ $t('login_email_secure') }}</span>

            <img v-if="logoSrc" :src="logoSrc" class="lp-logo">

            <input-text ref="inputEmail"
                        :big="true"
                        :data="loginEmail"
                        :error="isErrorEmail"
                        :errorMessage="$t('login_error_invalid_email_password')"
                        :name="'email'"
                        :placeholder="$t('login_email_placeholder')"
                        :type="'email'"
                        :valid="isValidEmail"
                        class="input-text"
                        @blur="emailChange();testEmail()"
                        @pressEnter="$refs.inputPassword.focus()"
                        @restart="isErrorEmail = false"
            ></input-text>

            <input-text
                        ref="inputPassword"
                        :big="true"
                        :error="isErrorPassword"
                        :name="'password'"
                        :placeholder="computedPasswordPlaceholder"
                        :type="'password'"
                        class="input-text"
                        @pressEnter="next"
                        @restart="isErrorPassword = false"
            ></input-text>

            <div v-show="error" class="error-container">
                <span class="error-text">{{ computedMessageError }}</span>
            </div>

            <button
                class="btn btn-blue full btn-next btn-big"
                @click="next"
            >{{ $t('global_cta_next') }}
            </button>

            <p v-if="appPass" class="create-app-pass link" @click="createAppPass">{{ computedLink }}</p>

            <img class="img-foxy-lock" src="/img/foxy/lock.png">

            <span class="span-secu">{{ $t('login_email_secure') }}</span>

        </div>

        <page-loader ref="loader"></page-loader>

        <modal-error-application-password ref="MEAP" @close="createAppPass"></modal-error-application-password>

        <modal-error-provider ref="MEP" :email="emailError" :provider="provider"></modal-error-provider>

        <modal-outlook-invalid-credentials ref="MOIC"></modal-outlook-invalid-credentials>

        <modal-login-long-fail ref="MLLF"></modal-login-long-fail>

        <modal-error-imap ref="MEI" @close="showImapStep"></modal-error-imap>

    </div>

</template>

<script>

import Vuex from 'vuex'
import Api from '../../api'

import SessionStorage from '../../helpers/sessionStorage'

import Auth from '../../modules/auth'
import Login from '../../modules/login'
import Providers from '../../modules/providers'
import Tag from '../../modules/tag'
import UserFlow from '../../modules/userFlow'
import Consent from '../../modules/consent'

import HeaderBand from '../../components/headers/HeaderBand'
import InputText from '../../components/inputs/InputText'
import Markdown from '../../components/Markdown'
import ModalErrorApplicationPassword from '../../components/modal/ModalErrorApplicationPassword'
import ModalErrorImap from '../../components/modal/ModalErrorImap'
import ModalErrorProvider from '../../components/modal/ModalErrorProvider'
import ModalLoginLongFail from '../../components/modal/ModalLoginLongFailed'
import ModalOutlookInvalidCredentials from '../../components/modal/ModalOutlookInvalidCredentials'
import PageLoader from '../../components/PageLoader'

import {routerPushHelper} from '../../router'

export default {

    name: 'login',

    components: {
        InputText,
        Markdown,
        ModalErrorApplicationPassword,
        ModalErrorImap,
        ModalErrorProvider,
        ModalLoginLongFail,
        PageLoader,
        HeaderBand,
        ModalOutlookInvalidCredentials
    },

    computed: {

        ...Vuex.mapGetters(['page', 'user', 'emailToDeleteRedirect']),

        computedMessageError: function () {
            if (this.errorMessage === 'timeout') {

                return this.$t('fetch_error_text')

            } else {

                if (this.$te(this.errorMessage)) {
                    return this.$t(this.errorMessage)
                } else {
                    return this.isGmx
                        ? this.$t('login_error_invalid_email_password_imap')
                        : this.$t('login_error_invalid_email_password')
                }

            }
        },

        isGmx() {
            return this.provider === 'gmx' || this.provider === 'web'
        },

        loginEmail() {
            return SessionStorage.getItem(SessionStorage.KEYS.EMAIL)
        },

        computedPasswordPlaceholder() {
            return this.appPass && !this.isGmx
                ? this.$t('login_application_password_placeholder')
                : this.$t('login_password_placeholder')
        },

        computedLink() {
            return this.isGmx
                ? this.$t('login_provider_imap_redirection')
                : this.$t('login_create_app_password')
        },

        getTitle() {
            return this.title || this.$t('login_title')
        }

    },

    props: {

        provider: {
            type: String,
            default: ''
        },

        logoSrc: {
            type: String,
            default: ''
        },

        appPass: {
            type: Boolean,
            default: false
        },

        title: {
            type: String,
            default: ''
        }

    },

    data() {
        return {
            error: false,
            // eslint-disable-next-line no-useless-escape
            regexMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
            isValidEmail: false,
            isErrorEmail: false,
            isErrorPassword: false,
            errorMessage: '',
            emailError: '',
            loading: false
        }
    },

    mounted() {

        if (SessionStorage.getItem(SessionStorage.KEYS.EMAIL)) {
            const self = this
            // this vue is faster than input-text component for get value
            setTimeout(function () {
                self.testEmail()
            }, 10)
            this.$refs.inputPassword.focus()
        } else {
            this.$refs.inputEmail.focus()
        }

    },

    methods: {

        next() {
            this.$refs.inputPassword.blur()
            const email = this.$refs.inputEmail.value

            if (this.testForm() && !this.loading) {

                this.loading = true

                this.$refs.loader.start()

                SessionStorage.setItem(SessionStorage.KEYS.EMAIL, email)

                Login.connect(this, email, this.$refs.inputPassword.value, this.provider)
                // eslint-disable-next-line complexity
                    .catch(error => {
                        this.loading = false
                        this.$refs.loader.stop()
                        this.$refs.inputPassword.focus()

                        this.error = true
                        const errorNumber = Auth.errorToStatus[error.message]
                        Tag.infoAll(this, 'status_final_connection', this.provider, errorNumber)

                        if (error.message) {

                            if (error.message === 'mx_unsupported' || error.message === 'mx_unsupported') {

                                this.$refs.MEP.show(error)

                            } else {

                                this.error = true
                                this.isErrorPassword = true

                                if (error.message === 'mailbox_already_associated') {
                                    this.errorMessage = 'login_email_already_associated'
                                } else {

                                    this.errorMessage = error.message

                                    switch (error.message) {
                                        case 'application_password':
                                            this.$refs.MOIC.open()
                                            break
                                        case 'imap_disabled':
                                            this.$refs.MEI.open()
                                            break
                                        case 'timeout':
                                            this.$refs.MLLF.open(this.provider)
                                            break
                                    }
                                }

                            }

                        } else {
                            this.errorMessage = ''
                        }
                    })

            } else {
                this.$refs.inputPassword.focus()
            }
        },

        testEmail() {

            const email = this.$refs.inputEmail.value

            if (email.length) {
                this.isValidEmail = email.length > 0 && this.regexMail.test(email)
                this.isErrorEmail = !this.regexMail.test(email)
                return this.isValidEmail && !this.isErrorEmail
            }

        },

        createAppPass() {

            this.$emit('goAppPass')

        },

        testPassword: function () {
            const inputPasswordLength = this.$refs.inputPassword.value.length

            const goodAppPassLength = this.provider === 'icloud' ? 19 : 16
            if (Providers.isSpecificProvider(this.provider) && !this.isGmx && inputPasswordLength !== goodAppPassLength) {
                this.$refs.MEAP.open()
                this.isErrorPassword = true
            } else {
                this.isErrorPassword = !inputPasswordLength
            }
            return !this.isErrorPassword
        },

        testForm() {
            return this.testEmail() && this.testPassword()
        },

        emailChange() {

            const emailStr = this.$refs.inputEmail.value

            if (this.regexMail.test(emailStr)) {

                SessionStorage.setItem(SessionStorage.KEYS.EMAIL, emailStr)

                Api.provider.get(emailStr)
                    .then(data => {
                        if(data.provider !== this.provider) {
                            Consent.resetAcceptedConsentIfRequired()
                            const path = UserFlow.getLoginPathPostMagicForm(data)
                            routerPushHelper(this.$router, path)
                        }
                    })
                    .catch(error => {

                        if (error.message === 'mx_unsupported' || error.message === 'mx_not_found') {

                            this.$refs.MEP.show(error)
                        }
                    })
            }
        },

        showImapStep() {
            this.$emit('showImapStep')
        }

    }
}
</script>

<style lang="scss" scoped>

.bloc-login-container {
    width: 100%;
    @media screen and (min-width: $above-tablet-length) {
        flex-grow: 1;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        display: flex;
        padding: 50px;
    }
}

.bloc-login {
    display: flex;
    flex-direction: column;
    padding: 26px 16px 32px;
    align-items: center;
    @media screen and (min-width: $above-tablet-length) {
        max-width: 501px;
        background-color: $white;
        border-radius: 8px;
        box-shadow: 0 2px 10px 3px rgba(0, 0, 0, 0.15);
        padding: 50px 24px 44px;
        width: 501px;
    }
}

.lp-logo {
    max-width: 128px;
    max-height: 72px;
    object-fit: contain;
    margin: 24px 0;
    @media screen and (min-width: $above-tablet-length) {
        max-width: 162px;
    }
}

.title-login {
    font-size: 21px;
    font-weight: bold;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 0px;
        font-size: 36px;
        line-height: 1.44;
        color: $midnight;
    }
}

.subtitle {
    margin-top: 8px;
    font-size: 12px;
    font-weight: 500;
    color: rgba(59, 59, 84, 0.6);
    @media screen and (min-width: $above-tablet-length) {
        font-size: 20px;
        line-height: 1.5;
        color: $grey;
    }
}

.input-text {
    margin-top: 16px;
    width: 100%;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 24px;
    }
}

.btn-next {
    margin-top: 16px;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 24px;
        height: 56px;
    }
}

.create-app-pass {
    margin-top: 19px;
}

.img-foxy-lock {
    margin-top: 16px;
    height: 74px;
    object-fit: contain;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 38px;
    }
}

.span-secu {
    margin-top: 11px;
    font-size: 10px;
    font-weight: 500;
    color: $secur-text;
    @media screen and (min-width: $above-tablet-length) {
        margin-top: 16px;
    }
}

.error-container {
    margin-top: 4px;
    min-height: 16px;
    text-align: start;
}

.error-text {
    font-size: 13px;
    color: $raspberry;
}


</style>
